/**
 * Small key-value storage: Capacitor Preferences in the apps (survives reinstalls on iOS through the
 * keychain-backed UserDefaults), localStorage on the web. Values are strings; callers encode JSON.
 */
import { Preferences } from '@capacitor/preferences';

import { isNative } from './env';

export interface Storage {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}

const PREFIX = 'terrella:';

const web: Storage = {
  get(key) {
    try {
      return Promise.resolve(localStorage.getItem(PREFIX + key));
    } catch {
      return Promise.resolve(null);
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch {
      /* private mode or full: the app works without it */
    }
    return Promise.resolve();
  },
  remove(key) {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      /* same */
    }
    return Promise.resolve();
  },
};

const native: Storage = {
  get: async (key) => (await Preferences.get({ key: PREFIX + key })).value,
  set: async (key, value) => Preferences.set({ key: PREFIX + key, value }),
  remove: async (key) => Preferences.remove({ key: PREFIX + key }),
};

export const storage: Storage = isNative ? native : web;
